import ImgDescCard from 'components/ImgDescCard';
import styled from 'styled-components';
import { vw } from 'components/common/Common';
import { Link } from '../JetCard.style';

const Container = styled.div`
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;
  gap: ${vw(20)};
`;

const SubTitle = styled.span`
  font-size: 16px;
  font-weight: 600;
  color: #07080a;
  font-family: 'Montserrat' !important;
`;

const SubDesc = styled.p`
  font-size: 16px;
  font-weight: 400;
  color: #07080a;
  line-height: 1.3;
`;

const Button = styled.div`
  display: flex;
  justify-content: flex-end;

  a {
    border: none;
    background-color: #0b8ae8;
    color: #fff;
    font-size: 14px;
    font-weight: 600;
    padding: ${vw(12)} 0;
    border-radius: ${vw(4)};
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 180px;
    line-height: normal;
  }
`;

const Content = styled.div`
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 16px;
`;

const StatPanel = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  padding: ${vw(24)};
`;

const StatHeader = styled.h3`
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #07080a;
  line-height: 1;
`;

const StatCard = styled.div`
  background: #0b8ae8;
  color: #fff;
  border-radius: ${vw(4)};
  padding: ${vw(16)};
  display: flex;
  flex-direction: column;
  gap: ${vw(4)};
`;

const StatCardSmall = styled.span`
  font-size: 16px;
  color: #fff;
  font-weight: 400;
  opacity: 0.9;
`;

const StatCardBig = styled.div`
  font-size: 40px;
  font-weight: 600;
  line-height: normal;
`;

const StatCardDesc = styled.span`
  font-size: 16px;
  color: #fff;
  font-weight: 400;
  opacity: 0.9;
`;

const StatCardContainer = styled.div`
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;
  gap: ${vw(16)};
`;

const WhyFly = () => {
  return (
    <Container>
      <ImgDescCard
        isLeft={false}
        gap={'unset'}
        imgSrc="/imgs/webp/jetCard/champagne.webp"
        imgAlt="Champagne and gourmet catering service during private jet flight"
        title="Why Fly With a Jet Card?"
        desc={[
          "Airacer’s dedicated trip assistants manage every facet of executive journeys, offering tailored solutions that align with your organization's travel objectives.",
          'Our end-to-end travel solutions cover everything from door-to-door transportation to meticulous itinerary planning, for a seamless journey.',
        ]}
        rightSlot={
          <StatPanel>
            <StatHeader>Proven Performance. Trusted Experience.</StatHeader>
            <StatCardContainer>
              <StatCard>
                <StatCardSmall>Topping</StatCardSmall>
                <StatCardBig>75,000</StatCardBig>
                <StatCardDesc>flight hours</StatCardDesc>
              </StatCard>
              <StatCard>
                <StatCardSmall>Over</StatCardSmall>
                <StatCardBig>10+</StatCardBig>
                <StatCardDesc>years in the industry</StatCardDesc>
              </StatCard>
              <StatCard>
                <StatCardSmall>More than</StatCardSmall>
                <StatCardBig>11,000+</StatCardBig>
                <StatCardDesc>satisfied passengers</StatCardDesc>
              </StatCard>
            </StatCardContainer>
          </StatPanel>
        }
      >
        <Content>
          <SubTitle>What is a Jet Card?</SubTitle>
          <SubDesc>
            Something that gives globetrotters of all walks - from business leaders to leisure
            flyers - access to private jet travel.
          </SubDesc>
          <Button>
            <Link href="/charterQuote">Book Flight</Link>
          </Button>
        </Content>
      </ImgDescCard>
    </Container>
  );
};

export default WhyFly;
